AddPageSwapTrigger(function(){
    $(".scroll-to-hash").unbind('click');
    $('.scroll-to-hash').click(function () { $('html, body').animate({scrollTop: $(this.hash).offset().top - 165}, 'fast'); return false; });
});